<template>
  <section>
    <PromotionProgress v-if="accountInfo.status !== 'CV'" :lots="accountInfo.lotsTraded" :status="accountInfo.status" />
    <PromotionComplete v-else :accountInfo="accountInfo" />
  </section>
</template>

<script>
import PromotionComplete from './PromotionComplete.vue';
import PromotionProgress from './PromotionProgress.vue';

export default {
  name: 'StatusOverview',
  props: {
    accountInfo: {
      type: Object,
      default: {
        participants: [],
        in: null,
        reachedMaximumBonus: null,
        creditLimit: null,
        welcomeRateLimit: null,
        showOptInPopup: null,
        hasDepositRecord: null,
        expired: null,
        expiring: null,
        expiredDate: null,
        status: null,
        lotsTraded: 0,
        accountType: null,
        mt4Account: null
      }
    }
  },
  components: { PromotionComplete, PromotionProgress },
  data() {
    return {
      primaryBlue: '#0051ff',
      lots: 0
    };
  },
  mounted() {
    console.log('accountInfo', this.accountInfo);
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.money-card-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 83px;

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    margin-top: 30px;
    flex-wrap: wrap;
  }
}
.v-divide {
  width: 1px;
  border-left: solid 1px #efefef;
  margin: 0 38px;

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    display: none;
  }
}
.exhange-table-wrapper {
  display: flex;
  padding: 15px;

  & .exhange-table-wrapper {
    flex-grow: 1;
  }

  & .reedem-and-remaining-table-wrapper {
    flex-grow: 1.8;
  }

  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    flex-wrap: wrap;
  }
}
.tradeinfo-table-wrapper {
  padding: 0 30px;
}

.trading-account-wrapper {
  position: absolute;
  right: 0px;
  top: 15px;
  width: auto;
  @media (max-width: $DEVICE_SIZE_MOBILEL) {
    right: 0;
    top: -173px;
    width: 95%;
  }

  @media (max-width: '1100px') {
    left: 50%;
    transform: translate(-50%, 0);
    top: 90px;
  }
}
</style>
